'use client';

import React from 'react';
import Header from '../global/partials/Header';
import Footer from '../global/partials/Footer';
import IntroSection from '../pageComponents/about-us/IntroSection';
import { PageAboutUsSchema } from '@/sanity/pages/PageAboutUsTemplate';
import HeroSection from '../pageComponents/about-us/HeroSection';
import FounderStorySection from '../pageComponents/about-us/FounderStorySection';
import FounderQuoteSection from '../pageComponents/about-us/FounderQuoteSection';
import VerifiedPerformanceSection from '../pageComponents/about-us/VerifiedPerformanceSection';
import IQManagementSection from '../pageComponents/about-us/IQManagementSection';
import PayoutRecordsSection from '../pageComponents/about-us/PayoutRecordsSection';
import TraderValuesSection from '../pageComponents/global/sections/TraderValuesSection';
import ScrollingBanner from '../pageComponents/global/ScrollingBanner';
import HeaderV2 from '../global/partials/HeaderV2';

export default function PageAboutUsJSX({ data }: { data: PageAboutUsSchema }) {
  return (
    <main className="flex flex-col items-center">
      {data?.settings?.header && (
        <HeaderV2
          data={data.settings.header}
          headerStyle="light"
          headerType={'main'} // showBorder
          language={data.settings?.language}
        />
      )}

      <HeroSection data={data} />
      <IntroSection data={data} />
      <FounderStorySection data={data} />
      <FounderQuoteSection data={data} />
      <VerifiedPerformanceSection data={data} />
      <PayoutRecordsSection data={data} />
      <IQManagementSection data={data} />

      <ScrollingBanner
        className="bg-[#f4f5f5] border-y-0"
        words={data.scrollingWords?.words}
        wordsI18n={data.scrollingWords?.wordsI18n}
      />

      {data?.settings?.footer && <Footer data={data.settings?.footer} finalCta={data} language={data?.settings?.language} />}
    </main>
  );
}
